// app/javascript/controllers/dae20/chat_filter_controller.js
// Simple client-side text filter for lists.
// Usage: wrap a list in data-controller="dae20--chat-filter",
//   input has data-dae20--chat-filter-target="input",
//   each filterable item has data-dae20--chat-filter-target="item"
//   and data-filter-text="searchable text".
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item"]

  filter() {
    const query = (this.inputTarget.value || "").trim().toLowerCase()
    this.itemTargets.forEach((el) => {
      const text = (el.dataset.filterText || el.textContent || "").toLowerCase()
      el.style.display = query === "" || text.includes(query) ? "" : "none"
    })
  }
}
